import { nanoid } from 'nanoid'

export const getSalt = () => nanoid(36)

// URL-encode pipe-joined parts
export const buildRequestId = (salt, startTime, eventTypeUUID, ...identifiers) => {
  // Delimit values with '|' to remove transposition non-uniqueness
  const keyParts = [
    salt, startTime, eventTypeUUID, identifiers
  ].flat()

  return encodeURIComponent(keyParts.join('|'))
}
